const THREE = require('three')
import {loadingManager, load, registerSize} from '../loader'

class PlaneSprite {
  constructor(url, size, w, h) {
    registerSize(url, size)

    let geometry = new THREE.PlaneBufferGeometry(w, h)

    let material = new THREE.MeshBasicMaterial({
      side: THREE.DoubleSide,
      transparent: true
    })

    let mesh = new THREE.Mesh(geometry, material)

    const loader = new THREE.TextureLoader(loadingManager)
    load(url, loader, (results)=> {
      material.map = results[0]
      material.needsUpdate = true
    })

    return mesh

  }

}

export default PlaneSprite







// WEBPACK FOOTER //
// ./src/components/game/result/plane-sprite.js